export enum AppRoutes {
    dashboard = "/",
    settings = "/settings",
    pdf = "/pdf",
    htmlFile = "/html_file",
    bibliography = "/bibliography",
    dictionary = "/dictionary",
    snippets = "/snippets",
    kanbanBoards = "/kanban-boards",
    equations = "/equations",
    viewMdxNote = "/mdx",
    splitViewEditMdx = "/mdx-split-view",
    embeddedDocs = "/embedded-docs",
    bookmarks = "/bookmarks",
    taskLists = "/taskLists",
    search = "/search",
    semanticSearch = "/semantic-search",
    onboarding = "/onboarding",
    aiMainChat = "/aiChat",
    notebookInteractive = "/notebook-interactive",
    constantsTable = "/docs-constants",
    full_screen_editor = "/editor-full",
}
